export const staffsArrPC: string[][] = [
  ["新 唯", "山﨑 光"],
  ["森 大地", "馬場嶺也", "西野夢菜", "パピコ"],
  ["齊藤英里", "新井萌花", "伊織いお", "寺中寿之 ／ 天野麻菜"],
  [
    "松田将希",
    "山口雄大",
    "波瀬嶋渚",
    "咲谷菜月",
    "山本桜夕",
    "八嶋瑞季",
    "小山田朱里",
    "崚 聖",
    "タカミ",
    "野間清史",
  ],
  [
    "原作：岡田和人『すんドめ』（秋田書店「ヤングチャンピオン・コミックス」刊）",
  ],
  [
    "監督：件 創一",
    "脚本：近藤 茶",
    "主題歌：『NEW JACKSON』SIMIFUNK（作詞/作曲：DUNK）",
  ],
  ["制作プロダクション：アフロディーテ"],
  [
    "製作：「すんドめ」製作委員会（カルチュア・エンタテインメント／オデッサ・エンタテインメント）",
  ],
];

export const staffsArrSP: string[][] = [
  ["新 唯", "山﨑 光"],
  ["森 大地", "馬場嶺也", "西野夢菜", "パピコ"],
  ["齊藤英里", "新井萌花", "伊織いお", "寺中寿之 ／ 天野麻菜"],
  [
    "松田将希",
    "山口雄大",
    "波瀬嶋渚",
    "咲谷菜月",
    "山本桜夕",
    "八嶋瑞季",
    "小山田朱里",
  ],
  ["崚 聖", "タカミ", "野間清史"],
  ["原作：岡田和人『すんドめ』"],
  ["（秋田書店「ヤングチャンピオン・コミックス」刊）"],
  ["監督：件 創一", "脚本：近藤 茶"],
  ["主題歌：『NEW JACKSON』SIMIFUNK（作詞/作曲：DUNK）"],
  ["制作プロダクション：アフロディーテ"],
  ["製作：「すんドめ」製作委員会"],
  ["（カルチュア・エンタテインメント／オデッサ・エンタテインメント）"],
];
